if (!customElements.get('bg-wholesale-box')) {
  customElements.define('bg-wholesale-box', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choice = this.querySelector('[data-box-select]');
      this.variantPhotos = Array.from(this.querySelectorAll('[data-variant-photo]'));
      this.variantPhotos.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.choice) {
          this.choice.value = link.dataset.variantPhoto;
          this.selectBox(true);
        } else {
          this.showPhoto(link.dataset);
          this.selectPhotoCard(link.dataset.variantPhoto);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', link.dataset.variantPhoto);
          window.history.replaceState({}, '', url);
        }
      }));
      this.galleryLinks = Array.from(this.querySelectorAll('[data-gallery-photo]'));
      this.galleryLinks.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const img = this.querySelector('[data-box-image] img');
        if (!img) return;
        event.preventDefault();
        this.showPhoto(link.dataset);
        this.galleryLinks.forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        const note = this.querySelector('[data-box-photo-note]');
        if (note) note.textContent = this.dataset.galleryNote;
      }));
      this.choice = this.querySelector('[data-box-select]');
      if (!this.choice) return;
      this.quantity = this.querySelector('[data-box-quantity]');
      this.button = this.querySelector('[data-box-add]');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency', currency:this.dataset.currency});
      this.choice.addEventListener('change', () => this.selectBox(true));
      this.quantity.addEventListener('input', () => this.updateTotal());
      this.querySelector('form').addEventListener('submit', event => {
        if (this.submitting || this.choice.selectedOptions[0].dataset.available !== 'true' || !this.quantity.checkValidity()) {
          event.preventDefault();
          this.quantity.reportValidity();
          return;
        }
        this.submitting = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.adding;
      });
      window.addEventListener('pageshow', () => {this.submitting = false; this.selectBox(false);});
      this.selectBox(false);
    }
    selectBox(updateUrl) {
      const option = this.choice.selectedOptions[0];
      const data = option.dataset;
      this.quantity.min = data.min || '1';
      this.quantity.step = data.step || '1';
      if (data.max) this.quantity.max = data.max; else this.quantity.removeAttribute('max');
      if (!this.quantity.checkValidity()) this.quantity.value = this.quantity.min;
      this.button.disabled = data.available !== 'true';
      this.button.textContent = data.available === 'true' ? this.dataset.available : this.dataset.unavailable;
      this.querySelector('[data-box-price]').textContent = data.money;
      this.querySelector('[data-box-unit-price]').textContent = data.unitPrice;
      this.querySelector('[data-box-sku]').textContent = data.sku;
      this.querySelector('[data-box-photo-note]').textContent = data.photoNote;
      this.showPhoto(data);
      this.selectPhotoCard(option.value);
      this.galleryLinks.forEach(item => {
        if (item.dataset.image === data.image) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      const template = Array.from(this.querySelectorAll('[data-box-template]')).find(item => item.dataset.boxTemplate === option.value);
      if (template) this.querySelector('[data-box-contents]').replaceChildren(template.content.cloneNode(true));
      if (updateUrl) {const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);}
      this.updateTotal();
    }
    selectPhotoCard(id) {
      this.variantPhotos.forEach(link => {
        if (link.dataset.variantPhoto === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
    showPhoto(data) {
      const img = this.querySelector('[data-box-image] img');
      if (img && data.image) {
        img.srcset = data.srcset || '';
        img.src = data.image;
        img.alt = data.alt || '';
        const enlarge = this.querySelector('[data-box-enlarge]');
        if (enlarge) {
          const url = new URL(data.image, window.location.href);
          url.searchParams.set('width', '1600');
          enlarge.href = url.href;
        }
      }
      const note = this.querySelector('[data-box-photo-note]');
      if (note && data.photoNote) note.textContent = data.photoNote;
    }
    updateTotal() {
      const count = Number(this.quantity.value);
      const valid = this.quantity.checkValidity() && Number.isSafeInteger(count) && count > 0;
      this.querySelector('[data-box-total]').textContent = valid ? this.formatter.format(Number(this.choice.selectedOptions[0].dataset.price) * count / 100) : '—';
      this.querySelector('[data-box-units]').textContent = valid ? this.dataset.unitSummary.replace('__count__', String(count * Number(this.dataset.count))) : '—';
    }
  });
}



